module.exports = __webpack_public_path__ + "static/img/Application.38f2fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutemobi/imgs/browse/Application.jpg
// module id = 2232
// module chunks = 0